import { Link } from "react-router-dom";

const STATS = [
  { value: "10,000+", label: "影视资源" },
  { value: "200+", label: "每日更新" },
  { value: "20+", label: "内容类型" },
  { value: "全端", label: "便捷浏览" },
];

export default function IntroSection() {
  return (
    <div className="overflow-hidden rounded-xl border border-background-300/60 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="order-2 flex flex-col justify-center p-6 md:p-10 lg:order-1">
          <span className="w-fit rounded-full bg-secondary-700 px-3 py-1 text-xs text-primary-400">
            关于秋霞网
          </span>
          <h2 className="mt-4 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
            丰富全面 · 便捷易用的影视内容门户
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-500 md:text-base">
            秋霞网专注于为用户聚合最新最全的电影与电视剧资源，涵盖科幻、悬疑、犯罪、剧情、爱情、古装等多元类型。我们以清晰的分类、强大的筛选与及时的更新，帮助每一位影迷快速找到想看的作品，了解第一手影视动态。
          </p>
          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {STATS.map((s) => (
              <div key={s.label}>
                <div className="font-heading text-2xl font-bold text-primary-500 md:text-3xl">
                  {s.value}
                </div>
                <div className="mt-1 text-xs text-foreground-500">{s.label}</div>
              </div>
            ))}
          </div>
          <div className="mt-8">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              了解秋霞网
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>

        <div className="order-1 h-56 w-full overflow-hidden lg:order-2 lg:h-auto">
          <img
            src="https://readdy.ai/api/search-image?query=Cinematic%20collection%20of%20glowing%20film%20reels%20and%20movie%20poster%20tiles%20floating%20in%20a%20dark%20space%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grading%2C%20modern%20moody%20lighting%2C%20film%20grain%2C%20no%20text&width=900&height=700&seq=qx-intro-image&orientation=squarish"
            alt="秋霞网影视内容"
            title="秋霞网 影视内容聚合"
            className="h-full w-full object-cover object-center"
          />
        </div>
      </div>
    </div>
  );
}